// extracted by mini-css-extract-plugin
export default {"quadro":"quadro_quadro__eg4QP"};